import Vue from 'vue'
import { Loading, MessageBox, Notification } from 'element-ui'
import Clipboard from 'clipboard'

// 日期格式化
const formatDate = (fmt, date) => {
  if ((fmt === '') | (fmt === 'datetime')) {
    fmt = 'YYYY-mm-dd HH:MM:SS'
  }
  if (fmt === 'date') {
    fmt = 'YYYY-mm-dd'
  }
  if (fmt === 'time') {
    fmt = 'HH:MM:SS'
  }
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(),
    // 年
    'm+': (date.getMonth() + 1).toString(),
    // 月
    'd+': date.getDate().toString(),
    // 日
    'H+': date.getHours().toString(),
    // 时
    'M+': date.getMinutes().toString(),
    // 分
    'S+': date.getSeconds().toString()
    // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}
const formatTimestamp = (fmt, timestamp) => {
  if (timestamp === undefined || timestamp === null || timestamp === '') {
    return ''
  } else {
    return formatDate(fmt, new Date(timestamp))
  }
}
// 四种message提示框
const success = (message) => {
  Notification({
    title: '成功！',
    type: 'success',
    message: message,
    position: 'bottom-right'
  })
}
const error = (message) => {
  Notification({
    title: '失败！',
    type: 'error',
    message: message,
    position: 'bottom-right'
  })
}
const info = (message) => {
  Notification({
    title: '信息！',
    type: 'info',
    message: message,
    position: 'bottom-right'
  })
}
const warning = (message) => {
  Notification({
    title: '警告！',
    type: 'warning',
    message: message,
    position: 'bottom-right'
  })
}
// 全屏的loading
let loadingInstance
const start = () => {
  loadingInstance = Loading.service({ fullscreen: true })
}
const stop = (timeout) => {
  if (!timeout) {
    timeout = 0
  }
  setTimeout(() => {
    Vue.nextTick(() => {
      // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close()
    })
  }, timeout)
}
// cookie设置
const set = (key, value, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toGMTString()
  document.cookie = key + '=' + value + ';path=/;' + expires
}
const get = (key) => {
  const name = key + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return undefined
}
// 获取当天的00点 到24点
const toDay = (run) => {
  if (run.startTime && run.endTime) {
    if (run.startTime !== '' || run.endTime !== '') {
      return [
        new Date(run.startTime.replace(/-/g, '/')).getTime(),
        new Date(run.endTime.replace(/-/g, '/')).getTime()
      ]
    }
  }
  const dt = new Date()
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const today = y + '-' + m + '-' + d + ' 00:00:00'
  const startTime = new Date(today.replace(/-/g, '/')).getTime()
  const endTime = startTime + 86400000
  return [startTime, endTime]
}
// 把秒转为时分秒
const formatSeconds = (value) => {
  const result = parseInt(value)
  const h =
    Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  const m =
    Math.floor((result / 60) % 60) < 10
      ? '0' + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60)
  const s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60)

  let res = ''
  if (h !== '00') res += `${h}时`
  if (m !== '00') res += `${m}分`
  res += `${s}秒`
  return res
}
const UUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return uuid
}

const toMonth = (time) => {
  const dt = new Date(time)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const today = y + '/' + m + '/' + '01 00:00:00'
  const startTime = new Date(today).getTime()
  const endTime = time + 86400000
  return [startTime, endTime]
}
/**
 * 文件大小 字节转换单位
 * @param size
 * @returns {string|*}
 */
const filterSize = (size) => {
  if (size === undefined) return ''
  if (size < pow1024(1)) return size + ' B'
  if (size < pow1024(2)) return (size / pow1024(1)).toFixed(2) + ' KB'
  if (size < pow1024(3)) return (size / pow1024(2)).toFixed(2) + ' MB'
  if (size < pow1024(4)) return (size / pow1024(3)).toFixed(2) + ' GB'
  return (size / pow1024(4)).toFixed(2) + ' TB'
}
// 求次幂
function pow1024 (num) {
  return Math.pow(1024, num)
}

const confirm = (confirmCallback, confirmText, cancelCallback) => {
  if (!confirmText) {
    confirmText = '请确认进行本次操作?'
  }
  MessageBox.confirm(confirmText, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    confirmCallback && confirmCallback()
  }).catch((error) => {
    if (error !== 'cancel') {
      error(error)
    }
    cancelCallback && cancelCallback()
    info('已取消操作')
  })
}

const clone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

const clearObj = (obj, value) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj[key] = value
    }
  }
  return obj
}

// 替换全部，oldWord如果有特殊字符需要 \ 转义，newWord无需
const replaceAll = (string, oldWord, newWord) => {
  return string.replace(new RegExp(oldWord, 'g'), newWord)
}

var clipboard
const copy = (text, e) => {
  if (clipboard) {
    clipboard.destroy()
  }
  clipboard = new Clipboard(e.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    if (text.length > 20) {
      success('复制成功: ' + text.slice(0, 20) + '...')
    } else {
      success('复制成功: ' + text)
    }
    // 释放内存
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    // 不支持复制
    error('复制失败！，请手动选中进行复制')
    // 释放内存
    clipboard.destroy()
  })
  // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
  clipboard.onClick(e)
}
function open (url) {
  if (url) {
    window.open(url, '_blank')
  }
}

export default function () {
  Vue.prototype.$confirm = confirm
  // 添加全局API
  Vue.prototype.$message = {
    success,
    info,
    warning,
    error
  }
  Vue.prototype.$loading = {
    start,
    stop
  }
  Vue.prototype.$cookie = {
    set,
    get
  }
  Vue.prototype.$date = {
    formatDate,
    formatTimestamp,
    toDay,
    formatSeconds,
    toMonth
  }
  Vue.prototype.$tool = {
    UUID,
    filterSize,
    replaceAll,
    clone,
    clearObj,
    MessageBox,
    copy,
    open
  }
}
